import { StatusesType } from '../../../../types';

export type JobStatusType = 'pending' | 'done' | 'sent' | string;

export interface JobStatusRes {
  id: string;
  status: StatusesType;
  jobNum: string | number;
  applicationId: string;
  fileReceived: string; // File Received '2024-01-08T00:00:00Z'
  filesCount: number;
  subRows: JobStatusSubRow[];
  type: 'paper' | 'eStatement' | 'pendingApproval';
  divertedDocuments?: { accountName: string; accountNumber: string }[];
}

export interface JobStatusSubRow {
  id: string;
  type: {
    shortName: 'Paper' | 'Elec';
    fullName: 'Paper' | 'Electronic';
  };
  scheduledDropDate: string | null; // If 'null' then show text 'waiting to assign date'
  actualDropDate: string | null;
  procId: string;
  numOfAccounts: number;
  numOfPages: number;
  numOfImages: number;
  status: StatusesType;
  jobId?: string;
}

export const jobData: JobStatusRes[] = [
  {
    id: '11',
    status: 'pending',
    type: 'pendingApproval',
    jobNum: 912345,
    applicationId: 'Stmt - Mortgage',
    fileReceived: '2024-01-08T21:53:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '77',
    status: 'pending',
    type: 'pendingApproval',
    jobNum: 913001,
    applicationId: 'Stmt - Mortgage',
    fileReceived: '2024-01-09T21:05:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1254',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350661',
        numOfAccounts: 56,
        numOfPages: 140,
        numOfImages: 168,
        status: 'running',
      },
      {
        id: 'job_id_2274',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: '2024-02-18T11:15:00Z',
        procId: '3280699',
        numOfAccounts: 214,
        numOfPages: 140,
        numOfImages: 499,
        status: 'running',
      },
    ],
  },
  {
    id: '22',
    status: 'done',
    type: 'eStatement',
    jobNum: 912346,
    applicationId: 'Stmt - Investment Property Billing',
    fileReceived: '2024-01-10T18:00:00Z',
    filesCount: 3,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '33',
    status: 'done',
    type: 'eStatement',
    jobNum: 912348,
    applicationId: 'Stmt', // 'Loan Coupons'
    fileReceived: '2024-01-11T04:03:00Z',
    filesCount: 9,
    subRows: [
      {
        id: 'job_id_6436',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-15T10:20:00Z',
        actualDropDate: '2024-02-17T06:25:00Z',
        procId: '2880888',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_72547',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-14T11:05:00Z',
        actualDropDate: null,
        procId: '2380659',
        numOfAccounts: 9,
        numOfPages: 43,
        numOfImages: 67,
        status: 'running',
      },
    ],
  },
  {
    id: '44',
    status: 'done',
    type: 'paper',
    jobNum: 912349,
    applicationId: 'Tax - 1099INT',
    fileReceived: '2024-01-18T05:25:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '55',
    status: 'approved',
    type: 'paper',
    jobNum: 891103,
    applicationId: 'Paper',
    fileReceived: '2024-01-19T17:55:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '54',
    status: 'earlyDrop',
    type: 'eStatement',
    jobNum: 421230,
    applicationId: 'Stmt',
    fileReceived: '2024-01-19T17:55:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '56',
    status: 'late',
    type: 'paper',
    jobNum: 532362,
    applicationId: 'Paper',
    fileReceived: '2024-01-19T17:55:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1252',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350659',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2272',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380669',
        numOfAccounts: 179,
        numOfPages: 543,
        numOfImages: 567,
        status: 'earlyDrop',
      },
    ],
  },
  {
    id: '66',
    status: 'pending',
    type: 'pendingApproval',
    jobNum: 912999,
    applicationId: 'Stmt - Mortgage',
    fileReceived: '2024-01-10T21:53:00Z',
    filesCount: 1,
    subRows: [
      {
        id: 'job_id_1253',
        type: { shortName: 'Paper', fullName: 'Paper' },
        scheduledDropDate: '2024-02-15T10:15:00Z',
        actualDropDate: '2024-02-17T11:15:00Z',
        procId: '4350660',
        numOfAccounts: 56,
        numOfPages: 150,
        numOfImages: 178,
        status: 'running',
      },
      {
        id: 'job_id_2273',
        type: { shortName: 'Elec', fullName: 'Electronic' },
        scheduledDropDate: '2024-02-12T20:01:00Z',
        actualDropDate: null,
        procId: '3380679',
        numOfAccounts: 79,
        numOfPages: 541,
        numOfImages: 566,
        status: 'earlyDrop',
      },
    ],
  },
];

function adjustDate(dateStr: string) {
  const date = new Date(dateStr);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  date.setFullYear(currentYear);
  date.setMonth(currentMonth - 1);

  return date.toISOString();
}

export const initialJobStatusData: JobStatusRes[] = jobData.map(job => ({
  ...job,
  fileReceived: adjustDate(job.fileReceived),
  subRows: job.subRows.map(sub => ({
    ...sub,
    scheduledDropDate: sub.scheduledDropDate ? adjustDate(sub.scheduledDropDate) : null,
    actualDropDate: sub.actualDropDate ? adjustDate(sub.actualDropDate) : null,
  })),
}));

export const JOBS_STORAGE_KEY = 'jobStatusData';

function loadJobStatusData(): JobStatusRes[] {
  try {
    const stored = localStorage.getItem(JOBS_STORAGE_KEY);

    if (stored) {
      return JSON.parse(stored) as JobStatusRes[];
    }
  } catch {
    // Use initial jobs when storage is empty or invalid.
  }

  return structuredClone(initialJobStatusData);
}

export const jobStatusData: JobStatusRes[] = loadJobStatusData();

export function getJobById(id: string | null | undefined) {
  if (!id) {
    return undefined;
  }

  return jobStatusData.find(job => job.id === id);
}

export function approveJob(id: string, divertedDocuments: JobStatusRes['divertedDocuments'] = []) {
  const job = getJobById(id);

  if (!job) {
    return;
  }

  const hasDivertedDocuments = (divertedDocuments?.length ?? 0) > 0;
  job.status = hasDivertedDocuments ? 'running' : 'approved';
  job.divertedDocuments = divertedDocuments;

  if (job.type === 'pendingApproval') {
    job.type = 'paper';
  }

  job.subRows = job.subRows.map(subRow => ({
    ...subRow,
    status: hasDivertedDocuments ? 'running' : 'approved',
  }));

  localStorage.setItem(JOBS_STORAGE_KEY, JSON.stringify(jobStatusData));
}
